import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Badge } from "@/components/Kit";
import { fmtDateTime } from "@/lib/date";
import { Smartphone, ExternalLink } from "lucide-react";

const inr = (n) => "₹" + (n || 0).toLocaleString("en-IN");
const COLOR = { COMPLETED: "#10B981", PENDING: "#F59E0B", CREATED: "#06B6D4", FAILED: "#F43F5E" };

export default function OnlineOrders() {
  const { school } = useAuth();
  const { data: orders = [] } = useQuery({ queryKey: ["online-orders"], queryFn: async () => (await api.get("/school/fees/online-orders")).data, refetchInterval: 15000 });
  return (
    <div className="ep-card mt-5 overflow-hidden" data-testid="online-orders">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-800 px-4 py-3">
        <p className="flex items-center gap-2 text-sm font-semibold text-white"><Smartphone size={15} className="text-indigo-300" /> Online payments (parent portal)</p>
        <a href={`/s/${school?.code}/fees`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs text-indigo-300 hover:text-white" data-testid="parent-pay-link"><ExternalLink size={13} /> Parent pay link: /s/{school?.code}/fees</a>
      </div>
      <table className="w-full text-sm">
        <thead><tr className="border-b border-slate-800 text-left text-xs uppercase tracking-wider text-slate-500"><th className="px-4 py-2.5">Order</th><th className="px-4 py-2.5">Student</th><th className="px-4 py-2.5">Gateway</th><th className="px-4 py-2.5 text-right">Amount</th><th className="px-4 py-2.5">Status</th><th className="px-4 py-2.5">Receipt</th></tr></thead>
        <tbody>
          {orders.slice(0, 25).map((o) => (
            <tr key={o.merchant_order_id} className="border-b border-slate-800/50" data-testid={`order-row-${o.merchant_order_id}`}>
              <td className="px-4 py-2 font-mono text-[11px] text-slate-400">{o.merchant_order_id}<br /><span className="text-slate-600">{fmtDateTime(o.created_at)}</span></td>
              <td className="px-4 py-2 text-white">{o.student_name}</td>
              <td className="px-4 py-2"><Badge color={o.gateway === "phonepe" ? "#6D28D9" : "#64748B"}>{o.gateway === "phonepe" ? `PhonePe · ${o.env}` : "Simulated (MOCK)"}</Badge></td>
              <td className="px-4 py-2 text-right font-semibold text-emerald-400">{inr(o.amount)}</td>
              <td className="px-4 py-2"><Badge color={COLOR[o.state] || "#94A3B8"}>{o.state}</Badge></td>
              <td className="px-4 py-2 font-mono text-xs text-indigo-300">{o.receipt_no || "—"}</td>
            </tr>
          ))}
          {!orders.length && <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-500">No online payments yet</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
